import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Button, Col, Empty, Input, Modal, Row, Table } from "antd"
import {useContext, useState} from "react"
import apiMaestras from "../../../../api/Maestras/api-maestras"
import { Area } from "../../../../models/Maestras/maestras.model"
import { openNotification } from "../../../../utils/Notifactions"
import {TemplateContext} from "../../../../utils/template_context";

interface IModalAreas {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    areas: Area[]
    obtenerAreas: Function
    datos: Area
    setDatos: Function
}


export const ModalAreas = ({ openModal, setOpenModal, isEdit, areas, obtenerAreas, datos, setDatos }: IModalAreas) => {

    const onCancel = () => {
        setOpenModal(false)
    }
    const context = useContext(TemplateContext);
    const [area, setArea] = useState<Area>({
        nombre: ''
    })

    const [datosArea, setDatosArea] = useState<Area>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })

    const [modalVisible, setModalVisible] = useState(false);
    const editArea = (datos: Area) => {
        setDatosArea(datos);
        setModalVisible(true);
    }


    const addArea = async () => {
        if (area.nombre !== '') {
            try {
                const data = await apiMaestras.crearArea(area);
                //console.log(data)
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerAreas();
                setArea({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const actualizarArea = async () => {
        try {
            const resp = await apiMaestras.actualizarArea(datosArea);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  })
            }
            obtenerAreas();
            setModalVisible(false)
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerAreas();
        setOpenModal(false);
        setArea({
            nombre: '',
        })
    }

    const guardarEdicion = async () => {
        try {
            const resp = await apiMaestras.actualizarArea(datos);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  })
            }
            obtenerAreas();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const deleteArea = async (datos: Area) => {
        try {
            const resp = await apiMaestras.eliminarArea(datos.id);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  })
            }
            obtenerAreas();
        } catch (error) {
            console.log(error);
        }
    }

    const columns: any = [
        {
            title: "Nombre expresión",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: Area) => (
                <div className="controls">
                    <EditOutlined onClick={() => editArea(datos)} />
                    <DeleteOutlined onClick={() => deleteArea(datos)} />
                </div>
            )
        },
    ]

    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar expresión</div>
                            )
                            :
                            (

                                <div>Crear expresión</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {isEdit ?
                    (
                        <Row>
                            <Col span={24}>
                                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                    Nombre expresión
                                </span>
                                <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <>
                            <Row>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre expresión
                                    </span>
                                    <Input value={area.nombre} onChange={(e) => setArea({ ...area, nombre: e.target.value })} />
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={addArea}>Guardar</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>Expresiones Creadas</div>
                                </Col>
                                <Col>
                                    <Table
                                        dataSource={areas}
                                        columns={columns}
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </Modal>
            {modalVisible &&
                <Modal
                    title="Editar expresión"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarArea}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre expresión
                            </span>
                            <Input value={datosArea.nombre} onChange={(e) => setDatosArea({ ...datosArea, nombre: e.target.value })} />
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
